import React, {
    useEffect,
    useState
} from "react";

import Swal from "sweetalert2";

import {
    FaFilePdf,
    FaSearch,
    FaSyncAlt
} from "react-icons/fa";

import API_BASE_URL from "../config/api";


const Results = () => {

    /* =========================================================
       STATES
    ========================================================= */

    const [papers, setPapers] = useState([]);

    const [results, setResults] = useState([]);

    const [selectedPaper, setSelectedPaper] = useState("");

    const [search, setSearch] = useState("");

    const [loadingPapers, setLoadingPapers] = useState(false);

    const [loadingResults, setLoadingResults] = useState(false);

    const [downloadingPDF, setDownloadingPDF] = useState(false);


    /* =========================================================
       PAGINATION
    ========================================================= */

    const [currentPage, setCurrentPage] = useState(1);

    const resultsPerPage = 15;


    /* =========================================================
       GET PAPERS
    ========================================================= */

    const fetchPapers = async () => {

        try {

            setLoadingPapers(true);

            const response = await fetch(
                `${API_BASE_URL}/admin/results/papers`,
                {
                    method: "GET",

                    headers: {
                        Accept: "application/json"
                    },

                    credentials: "include"
                }
            );


            const data = await response.json();


            console.log(
                "RESULT PAPERS RESPONSE:",
                data
            );


            if (
                response.ok &&
                data.success
            ) {

                setPapers(
                    Array.isArray(data.papers)
                        ? data.papers
                        : []
                );

            } else {

                setPapers([]);

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text:
                        data.message ||
                        "Unable to fetch papers"
                });

            }


        } catch (error) {

            console.error(
                "Fetch papers error:",
                error
            );


            setPapers([]);


            Swal.fire({
                icon: "error",
                title: "Server Error",
                text:
                    "Unable to connect with server"
            });


        } finally {

            setLoadingPapers(false);

        }

    };


    /* =========================================================
       GET RESULTS
    ========================================================= */

    const fetchResults = async (paperId) => {

        if (!paperId) {

            setResults([]);

            return;

        }


        try {

            setLoadingResults(true);


            const response = await fetch(
                `${API_BASE_URL}/admin/results?paper_id=${encodeURIComponent(
                    paperId
                )}`,
                {
                    method: "GET",

                    headers: {
                        Accept: "application/json"
                    },

                    credentials: "include"
                }
            );


            const data = await response.json();


            console.log(
                "RESULT API RESPONSE:",
                data
            );


            if (
                response.ok &&
                data.success
            ) {

                setResults(
                    Array.isArray(data.results)
                        ? data.results
                        : []
                );

                setCurrentPage(1);

            } else {

                setResults([]);

                Swal.fire({
                    icon: "warning",
                    title: "No Results",
                    text:
                        data.message ||
                        "No results found"
                });

            }


        } catch (error) {

            console.error(
                "Fetch results error:",
                error
            );


            setResults([]);


            Swal.fire({
                icon: "error",
                title: "Server Error",
                text:
                    "Unable to connect with server"
            });


        } finally {

            setLoadingResults(false);

        }

    };


    /* =========================================================
       INITIAL LOAD
    ========================================================= */

    useEffect(() => {

        fetchPapers();

    }, []);


    /* =========================================================
       PAPER CHANGE
    ========================================================= */

    const handlePaperChange = (event) => {

        const paperId = event.target.value;


        setSelectedPaper(paperId);

        setSearch("");

        setCurrentPage(1);


        if (paperId) {

            fetchResults(paperId);

        } else {

            setResults([]);

        }

    };


    /* =========================================================
       SEARCH
    ========================================================= */

    const filteredResults = results.filter(
        (result) => {

            const searchText =
                search
                    .toLowerCase()
                    .trim();


            if (!searchText) {

                return true;

            }


            return (

                String(
                    result.fullname || ""
                )
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(
                    result.user_id || ""
                )
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(
                    result.category || ""
                )
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(
                    result.paper || ""
                )
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(
                    result.email || ""
                )
                    .toLowerCase()
                    .includes(searchText)

            );

        }
    );


    /* =========================================================
       PAGINATION
    ========================================================= */

    const totalPages = Math.ceil(
        filteredResults.length /
        resultsPerPage
    );


    const indexOfLastResult =
        currentPage *
        resultsPerPage;


    const indexOfFirstResult =
        indexOfLastResult -
        resultsPerPage;


    const currentResults =
        filteredResults.slice(
            indexOfFirstResult,
            indexOfLastResult
        );


    /* =========================================================
       CHANGE PAGE
    ========================================================= */

    const changePage = (page) => {

        if (
            page < 1 ||
            page > totalPages
        ) {

            return;

        }


        setCurrentPage(page);

    };


    /* =========================================================
       DOWNLOAD ALL RESULTS PDF
    ========================================================= */

    const handleDownloadAllPDF = async () => {

        if (!selectedPaper) {

            Swal.fire({
                icon: "warning",
                title: "Select Paper",
                text:
                    "Please select a paper first."
            });

            return;

        }


        try {

            setDownloadingPDF(true);


            const pdfUrl =
                `${API_BASE_URL}/admin/results/paper/${encodeURIComponent(
                    selectedPaper
                )}/pdf`;


            console.log(
                "DOWNLOAD ALL PDF URL:",
                pdfUrl
            );


            const response = await fetch(
                pdfUrl,
                {
                    method: "GET",

                    headers: {
                        Accept: "application/pdf"
                    },

                    credentials: "include"
                }
            );


            if (!response.ok) {

                let errorMessage =
                    "Unable to generate PDF.";

                try {

                    const errorData =
                        await response.json();

                    errorMessage =
                        errorData.message ||
                        errorMessage;

                } catch (error) {

                    console.error(
                        "PDF error response:",
                        error
                    );

                }


                throw new Error(
                    errorMessage
                );

            }


            const blob =
                await response.blob();


            const blobUrl =
                window.URL.createObjectURL(
                    blob
                );


            const selectedPaperData =
                papers.find(
                    (paper) =>
                        String(
                            paper.paper_id
                        ) ===
                        String(
                            selectedPaper
                        )
                );


            const paperName =
                selectedPaperData?.paper ||
                "results";


            const safePaperName =
                paperName
                    .replace(
                        /[^a-z0-9]/gi,
                        "-"
                    )
                    .replace(
                        /-+/g,
                        "-"
                    )
                    .replace(
                        /^-|-$/g,
                        ""
                    );


            const link =
                document.createElement(
                    "a"
                );


            link.href = blobUrl;


            link.download =
                `all-results-${safePaperName || "paper"}.pdf`;


            document.body.appendChild(
                link
            );


            link.click();


            document.body.removeChild(
                link
            );


            window.URL.revokeObjectURL(
                blobUrl
            );


            Swal.fire({
                icon: "success",
                title: "PDF Downloaded",
                text:
                    "All student results have been downloaded successfully.",
                timer: 1800,
                showConfirmButton: false
            });


        } catch (error) {

            console.error(
                "Download all PDF error:",
                error
            );


            Swal.fire({
                icon: "error",
                title: "PDF Error",
                text:
                    error.message ||
                    "Unable to download PDF."
            });


        } finally {

            setDownloadingPDF(false);

        }

    };


    /* =========================================================
       REFRESH
    ========================================================= */

    const handleRefresh = () => {

        if (selectedPaper) {

            fetchResults(
                selectedPaper
            );

        } else {

            fetchPapers();

        }

    };


    /* =========================================================
       RENDER
    ========================================================= */

    return (

        <div
            className="container-fluid py-4"
            style={{
                maxHeight: "calc(100vh - 80px)",
                overflowX: "auto",
                overflowY: "auto"
            }}
        >

            {/* =================================================
                HEADER
            ================================================= */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-4
                    flex-wrap
                    gap-2
                "
            >

                <div>

                    <h3 className="mb-1">
                        Results
                    </h3>

                    <p className="text-muted mb-0">
                        Manage student examination results
                    </p>

                </div>


                {/* HEADER BUTTONS */}

                <div
                    className="
                        d-flex
                        gap-2
                    "
                >

                    {/* DOWNLOAD ALL PDF */}

                    <button
                        type="button"
                        className="
                            btn
                            btn-danger
                        "
                        onClick={
                            handleDownloadAllPDF
                        }
                        disabled={
                            !selectedPaper ||
                            downloadingPDF ||
                            loadingResults ||
                            results.length === 0
                        }
                    >

                        <FaFilePdf
                            className="me-2"
                        />

                        {downloadingPDF
                            ? "Generating PDF..."
                            : "Download All PDF"}

                    </button>


                    {/* REFRESH */}

                    <button
                        type="button"
                        className="
                            btn
                            btn-outline-primary
                        "
                        onClick={
                            handleRefresh
                        }
                        disabled={
                            loadingPapers ||
                            loadingResults
                        }
                    >

                        <FaSyncAlt
                            className="me-2"
                        />

                        Refresh

                    </button>

                </div>

            </div>


            {/* =================================================
                FILTER CARD
            ================================================= */}

            <div
                className="
                    card
                    shadow-sm
                    border-0
                    mb-4
                "
            >

                <div className="card-body">

                    <div className="row g-3">

                        {/* =================================================
                            PAPER SELECT
                        ================================================= */}

                        <div className="col-md-7">

                            <label
                                className="
                                    form-label
                                    fw-semibold
                                "
                            >

                                Select Paper

                            </label>


                            <select
                                className="form-select"
                                value={selectedPaper}
                                onChange={
                                    handlePaperChange
                                }
                                disabled={
                                    loadingPapers
                                }
                            >

                                <option value="">
                                    -- Select Paper --
                                </option>


                                {papers.map(
                                    (paper) => (

                                        <option
                                            key={
                                                paper.paper_id
                                            }
                                            value={
                                                paper.paper_id
                                            }
                                        >

                                            {
                                                paper.paper
                                            }

                                            {paper.category
                                                ? ` (${paper.category})`
                                                : ""}

                                        </option>

                                    )
                                )}

                            </select>


                            {loadingPapers && (

                                <div
                                    className="
                                        small
                                        text-muted
                                        mt-2
                                    "
                                >

                                    Loading papers...

                                </div>

                            )}

                        </div>


                        {/* =================================================
                            SEARCH
                        ================================================= */}

                        <div className="col-md-5">

                            <label
                                className="
                                    form-label
                                    fw-semibold
                                "
                            >

                                Search

                            </label>


                            <div className="input-group">

                                <span
                                    className="
                                        input-group-text
                                    "
                                >

                                    <FaSearch />

                                </span>


                                <input
                                    type="text"
                                    className="
                                        form-control
                                    "
                                    placeholder="
                                        Search student name, user ID or email
                                    "
                                    value={search}
                                    onChange={(event) => {

                                        setSearch(
                                            event.target.value
                                        );

                                        setCurrentPage(1);

                                    }}
                                    disabled={
                                        !selectedPaper
                                    }
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                RESULT TABLE
            ================================================= */}

            <div
                className="
                    card
                    shadow-sm
                    border-0
                "
            >

                <div className="card-body">


                    {/* =================================================
                        LOADING
                    ================================================= */}

                    {loadingResults ? (

                        <div
                            className="
                                text-center
                                py-5
                            "
                        >

                            <div
                                className="
                                    spinner-border
                                    text-primary
                                "
                                role="status"
                            />

                            <div className="mt-2">

                                Loading results...

                            </div>

                        </div>


                    ) : !selectedPaper ? (

                        <div
                            className="
                                text-center
                                py-5
                                text-muted
                            "
                        >

                            Please select a paper
                            to view results.

                        </div>


                    ) : filteredResults.length === 0 ? (

                        <div
                            className="
                                text-center
                                py-5
                                text-muted
                            "
                        >

                            No results found.

                        </div>


                    ) : (

                        <div className="table-responsive">

                            <table
                                className="
                                    table
                                    table-bordered
                                    table-hover
                                    align-middle
                                "
                            >

                                <thead
                                    className="
                                        table-light
                                    "
                                >

                                    <tr>

                                        <th width="70">
                                            #
                                        </th>

                                        <th>
                                            Name
                                        </th>

                                        <th>
                                            User ID
                                        </th>

                                        <th>
                                            Score
                                        </th>

                                        <th>
                                            Category
                                        </th>

                                        <th>
                                            Paper
                                        </th>

                                    </tr>

                                </thead>


                                <tbody>

                                    {currentResults.map(
                                        (
                                            result,
                                            index
                                        ) => (

                                            <tr
                                                key={
                                                    result.id ||
                                                    `${result.user_id}-${index}`
                                                }
                                            >

                                                <td>

                                                    {
                                                        indexOfFirstResult +
                                                        index +
                                                        1
                                                    }

                                                </td>


                                                <td>

                                                    <strong>

                                                        {
                                                            result.fullname ||
                                                            "-"
                                                        }

                                                    </strong>


                                                    {result.email && (

                                                        <div
                                                            className="
                                                                small
                                                                text-muted
                                                            "
                                                        >

                                                            {
                                                                result.email
                                                            }

                                                        </div>

                                                    )}

                                                </td>


                                                <td>

                                                    {
                                                        result.user_id ||
                                                        "-"
                                                    }

                                                </td>


                                                <td>

                                                    <strong>

                                                        {
                                                            result.score ??
                                                            0
                                                        }

                                                    </strong>

                                                </td>


                                                <td>

                                                    {
                                                        result.category ||
                                                        "-"
                                                    }

                                                </td>


                                                <td>

                                                    {
                                                        result.paper ||
                                                        "-"
                                                    }

                                                </td>

                                            </tr>

                                        )
                                    )}

                                </tbody>

                            </table>

                        </div>

                    )}


                    {/* =================================================
                        PAGINATION
                    ================================================= */}

                    {!loadingResults &&
                        selectedPaper &&
                        filteredResults.length > 0 &&
                        totalPages > 1 && (

                            <div
                                className="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                    mt-3
                                    flex-wrap
                                    gap-2
                                "
                            >

                                <div
                                    className="
                                        text-muted
                                        small
                                    "
                                >

                                    Showing{" "}

                                    {
                                        indexOfFirstResult + 1
                                    }

                                    {" - "}

                                    {
                                        Math.min(
                                            indexOfLastResult,
                                            filteredResults.length
                                        )
                                    }

                                    {" of "}

                                    {
                                        filteredResults.length
                                    }

                                </div>


                                <nav>

                                    <ul
                                        className="
                                            pagination
                                            mb-0
                                        "
                                    >

                                        {/* PREVIOUS */}

                                        <li
                                            className={`page-item ${
                                                currentPage === 1
                                                    ? "disabled"
                                                    : ""
                                            }`}
                                        >

                                            <button
                                                type="button"
                                                className="page-link"
                                                onClick={() =>
                                                    changePage(
                                                        currentPage - 1
                                                    )
                                                }
                                                disabled={
                                                    currentPage === 1
                                                }
                                            >

                                                Previous

                                            </button>

                                        </li>


                                        {/* PAGE NUMBERS */}

                                        {Array.from(
                                            {
                                                length:
                                                    totalPages
                                            },
                                            (_, index) => (

                                                <li
                                                    key={
                                                        index + 1
                                                    }
                                                    className={`page-item ${
                                                        currentPage ===
                                                        index + 1
                                                            ? "active"
                                                            : ""
                                                    }`}
                                                >

                                                    <button
                                                        type="button"
                                                        className="
                                                            page-link
                                                        "
                                                        onClick={() =>
                                                            changePage(
                                                                index + 1
                                                            )
                                                        }
                                                    >

                                                        {
                                                            index + 1
                                                        }

                                                    </button>

                                                </li>

                                            )
                                        )}


                                        {/* NEXT */}

                                        <li
                                            className={`page-item ${
                                                currentPage ===
                                                totalPages
                                                    ? "disabled"
                                                    : ""
                                            }`}
                                        >

                                            <button
                                                type="button"
                                                className="page-link"
                                                onClick={() =>
                                                    changePage(
                                                        currentPage + 1
                                                    )
                                                }
                                                disabled={
                                                    currentPage ===
                                                    totalPages
                                                }
                                            >

                                                Next

                                            </button>

                                        </li>

                                    </ul>

                                </nav>

                            </div>

                        )}

                </div>

            </div>

        </div>

    );

};


export default Results;